/** @jsxImportSource @emotion/react */
/* eslint-disable */
import * as s from './style'
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { GEOSERVER } from 'config/URL/URL';
import Map from 'ol/Map';
import { Overlay, View } from 'ol';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import { getCenter } from 'ol/extent';
import { ImageWMS, TileWMS, XYZ } from 'ol/source';
import TileLayer from 'ol/layer/Tile';
import ImageLayer from 'ol/layer/Image';
import VectorLayer from 'ol/layer/Vector';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
import { click } from 'ol/events/condition';
import ModeSelectMenuButton from './mode_select_menu_button/ModeSelectMenuButton';
import MapFunction from './map_function/MapFunction';
import Select from 'ol/interaction/Select';
import Popup from './popup/Popup';
import zIndex from '@mui/material/styles/zIndex';

const CustomMap = ({ selectedCategories, selectedSido, selectedSgg, setSelectedSgg, mode, setMode }) => {
    const mapRef = useRef();
    const [ dataLayers, setDataLayers ] = useState();
    const [ activeLayers, setActiveLayers ] = useState();
    const [ selectedLayer, setSelectedLayer ] = useState();

    const [ overlayStates, setOverlayStates ] = useState();
    const [ borderLayers, setBorderLayers ] = useState();
    const [ sidoBorderLayers, setSidoBorderLayers ] = useState();
    
    const [ viewState, setViewState ] = useState();

    const [ popupData, setPopupData ] = useState({
        adminNm: "",
        data: [{ category: "", val: "" }, { category: "", val: "" }]
    });

    const [ clickedCoordinate, setClickedCoordinate ] = useState();

    useEffect(() => {
        initMap();
    }, []);

    useEffect(() => {
        let eventKeyArray;
        
        if(activeLayers && mode && borderLayers.length > 1) {
            const option = {
                map: mapRef.current,
                selectedLayer: selectedLayer,
                setSelectedLayer: setSelectedLayer,
                onClickMapHandle: onClickMapHandle,
                layers: activeLayers,
                borderLayer: borderLayers[1],
                sidoBorderLayer: sidoBorderLayers[1],
                setOverlayStates: setOverlayStates
            }

            const selectedFunction = MapFunction(mode);
            eventKeyArray = selectedFunction(option).mount();

            return () => {
                selectedFunction(option).dismount(eventKeyArray)
            }
        }

    }, [mode, activeLayers, borderLayers])

    useEffect(() => {
        if(selectedCategories[0]?.year) {
            const category = selectedCategories[0];
            fetchDataLayer(category.year, category, activeLayers[0], 0);

            return () => {
                activeLayers[0].setSource();
            }
        }

    }, [selectedCategories[0], activeLayers])

    useEffect(() => {
        if(selectedCategories[1]?.year) {
            const category = selectedCategories[1];    

            fetchDataLayer(category.year, category, activeLayers[1], 0);

            return () => {
                activeLayers[1].setSource();
            }
        }

    }, [selectedCategories[1], activeLayers])

    useEffect(() => {
        if(dataLayers && selectedSgg.adminCd !== "") {
            borderLayers.forEach((borderLayer, idx) => {
                fetchVectorLayer(borderLayer, selectedSgg.adminCd).then((borderLayerSource) => {
                    if(borderLayerSource && idx < 1) {
                        const newCoord = getCenter(borderLayerSource.getExtent());
                        setClickedCoordinate(newCoord);
                    }
                });
            })
        }

        if(dataLayers && selectedSgg.adminCd === "") {
            overlayStates.forEach((overlayState) => {
                overlayState.setPosition(undefined);
            })

            borderLayers.forEach((borderLayer) => {
                resetBorderLayer(borderLayer);
            })

            setClickedCoordinate(undefined);
        }

    }, [selectedSgg, mode])

    useEffect(() => {
        if(selectedSido) {
            sidoBorderLayers?.forEach((layer) => {
                fetchVectorLayer(layer, selectedSido.sidoCd).then((borderLayerSource) => 
                    viewState.fit(borderLayerSource.getFeatures()[0].getGeometry())
                )
            });
        } else {
            sidoBorderLayers?.forEach((layer) => {
                resetBorderLayer(layer);
            })
        }
    }, [selectedSido, mode])

    useEffect(() => {
        if(clickedCoordinate) {
            selectedCategories.forEach((category, idx) => {
                if(category.data) {
                    setPopupData((prev) => {
                        const newSggNm = selectedSgg.adminNm;
                        const newData = [...prev.data];
                        const findedData = category.data.find((data) => data.adminCd.trim() === selectedSgg.adminCd.trim() && data.year == category.year);
                        if(findedData) {
                            newData[idx] = {
                                category: category.nm_kor,
                                val: findedData.val
                            }                    
                            return {
                                adminNm: newSggNm,
                                data: newData
                            };

                        } else {
                            return prev;
                        }
                    })

                }
            });
            overlayStates.forEach((overlay) => {
                if(overlay) {
                    overlay.setPosition(clickedCoordinate);
                } 
            });
        }
    }, [clickedCoordinate, mode, selectedCategories])

    useEffect(() => {
        if(selectedLayer && mode === "singleMap") {
            activeLayers.forEach((layer) => {
                if(layer === selectedLayer) {
                    layer.setVisible(true);
                } else {
                    layer.setVisible(false);
                }
            })
        }
        
    }, [selectedLayer, mode])

    const initMap = async () => {
        if(!mapRef.current) {
            const vworldLayer = new TileLayer({
                title: 'VWorld white Map',
                visible: true,
                type: 'white',
                source: new XYZ({
                    url: 'https://xdworld.vworld.kr/2d/white/service/{z}/{x}/{y}.png'
                })
            });

            const sidoWmsLayer = new ImageLayer({
                properties: {
                    layerName: 'sido_wms'
                },
                source: new ImageWMS({
                    url: GEOSERVER + '/geoserver1/wms',
                    params: { 'LAYERS': 'gis_solution:ts_admin_sido' },
                    ratio: 1,
                    serverType: 'geoserver',
                }),
                opacity: 0.8,
                zIndex: 99
            })

            const sggWmsLayer = new ImageLayer({
                properties: {
                    layerName: 'sgg_wms'
                },
                source: new ImageWMS({
                    url: GEOSERVER + '/geoserver1/wms',
                    params: { 'LAYERS': 'gis_solution:ts_admin_sgg' },
                    ratio: 1,
                    serverType: 'geoserver',
                }),
                opacity: 0.8,
                zIndex: 98
            })
            
            const view = new View({
                center: [1.420517405965338E7, 4294546.35698363],
                zoom: 7.5,
                maxZoom: 13,
                minZoom: 7
            });

            setViewState(view);

            const imageLayer0 = new TileLayer({
                properties: {
                    layerName: 'image_layer_0'
                },
                zIndex: 90
            });


            const imageLayer1 = new TileLayer({
                properties: {
                    layerName: 'image_layer_1'
                },
                zIndex: 90
            });

            setDataLayers({
                imageLayer: [imageLayer0, imageLayer1]
            });

            setActiveLayers([imageLayer0, imageLayer1]);

            const vectorLayer0 = new VectorLayer({
                properties: {
                    layerName: 'vector_layer_0'
                },
            })

            const vectorLayer1 = new VectorLayer({
                properties: {
                    layerName: 'vector_layer_1'
                },
            })

            const borderLayer1 = new VectorLayer({
                properties: {
                    layerName: 'border_layer'
                },
                style: new Style({
                    stroke: new Stroke({
                        color: "#FF9112",
                        width: 3
                    }),
                    zIndex: 98
                }),
                zIndex: 98,
                tableName: "vl_data",
                condition: `admin_cd=`
            })

            const borderLayer2 = new VectorLayer({
                properties: {
                    layerName: 'border_layer'
                },
                style: new Style({
                    stroke: new Stroke({
                        color: "#FF9112",
                        width: 3
                    }),
                    zIndex: 98
                }),
                zIndex: 98,
                tableName: "vl_data",
                condition: `admin_cd=`
            })

            setBorderLayers([borderLayer1, borderLayer2]);

            const sidoBordorLayer1 = new VectorLayer({
                properties: ({
                    layerName: 'selected_sido_border',
                    tableName: "ts_admin_sido",
                    condition: `sido_cd=`
                }),
                style: new Style({
                    stroke: new Stroke({
                        color: 'yellow',
                        width: 5
                    })
                }),
                zIndex: 99
            });

            const sidoBordorLayer2 = new VectorLayer({
                properties: ({
                    layerName: 'selected_sido_border',
                    tableName: "ts_admin_sido",
                    condition: `sido_cd=`
                }),
                style: new Style({
                    stroke: new Stroke({
                        color: 'yellow',
                        width: 5
                    })
                }),
                zIndex: 99
            });

            setSidoBorderLayers([sidoBordorLayer1, sidoBordorLayer2]);


            const overlay = new Overlay({
                element: document.getElementById('popup_0'),
                autoPan: true,
                autoPanAnimation: {
                duration: 250,
                },
            });
            
            setOverlayStates([overlay]);

            const map = new Map({
                layers: [vworldLayer, sidoWmsLayer, sggWmsLayer, imageLayer0, imageLayer1, vectorLayer0, vectorLayer1, borderLayer1, sidoBordorLayer1],
                target: "map_area",
                view: view,
                overlays: [overlay]
            });

            map.on('click', onClickMapHandle);
            
            mapRef.current = map;   
        }
    }

    const fetchDataLayer = async (year, category, layer, index) => {
        const dataLayerSource = await getDataLayerWMSSource(year, category);
        layer.setSource(dataLayerSource);
        if(clickedCoordinate) {
            onChangeClickedCorrdinate(layer, index);
        }
    }
    
    const getDataLayerWMSSource = async (year, category) => {
        const dataLayerSource = new TileWMS({
            url: GEOSERVER + '/geoserver/wms',
            params: {
                'LAYERS': 'gis_solution:vl_data',
                'viewparams': 'year:' + year + ';keyword:' + category.nm_en + ';',
                'STYLES': 'sty_' + category.nm_en + '_sgg',
            },
            ratio: 1,
            serverType: 'geoserver',
        })
    
        return dataLayerSource;
    }

    const onChangeClickedCorrdinate = async (layer) => {
        if(layer.getSource()) {
            const url = layer.getSource().getFeatureInfoUrl(
                clickedCoordinate,
                mapRef.current.getView().getResolution(),
                'EPSG:3857',
                { 'INFO_FORMAT': 'application/json' }
            )
    
            try {
                const response = await axios.get(url);
                
                const borderLayerSource = new VectorSource({
                    features: new GeoJSON().readFeatures(response.data.features[0])
                })
                
                borderLayers.forEach((borderLayer) => {
                    borderLayer.setSource(borderLayerSource);
                })

                overlayStates.forEach((overlayState) => {
                    overlayState.setPosition(getCenter(borderLayerSource.getExtent()))
                });

                return response.data;
            
            } catch (error) {
                borderLayers.forEach((borderLayer) => {
                    borderLayer.setSource();
                });
                return null;
            }
        }
    }    
    
    const resetBorderLayer = (layer) => {
        if(layer) {
            const borderLayerSource = new VectorSource();
            layer.setSource(borderLayerSource);
        }
    }
    
    const onClickMapHandle = (e) => {
        fetchSggByCoord(e.map, e.coordinate)
    }

    const fetchSggByCoord = async (map, coordinate) => {
        const sggData = await getSggByCoord(map, coordinate);
        setSelectedSgg(sggData);
    }

    const getSggByCoord = async (map, coordinate) => {        
        const layer = map.getLayers().getArray().find((layer) => {
            const nm = layer.get("layerName");
            if(nm !== undefined && nm.indexOf('image_layer') !== -1) {
                return layer;
            }
        });

        const view = map.getView();

        const url = layer.getSource().getFeatureInfoUrl(
            coordinate,
            view.getResolution(),
            'EPSG:3857',
            { 'INFO_FORMAT': 'application/json' }
        )
        
        try {
            const response = await axios.get(url);
            const sggData = response.data.features[0].properties;

            const result = {
                adminCd: sggData.admin_cd,
                adminNm: sggData.admin_nm
            }

            return result;

        } catch (error) {
            const result = {
                adminCd: "",
                adminNm: ""
            }

            return result;
        }
    }

    const onClickCloseButton = () => {
        overlayStates.forEach((overlayState) => {
            overlayState.setPosition(undefined);
        })

        borderLayers.forEach((borderLayer) => {
            resetBorderLayer(borderLayer);
        })

        setSelectedSgg({
            adminCd: "",
            adminNm: ""
        })
    }

    const fetchVectorLayer = async (layer, code) => {
        const { tableName, condition } = layer.getProperties();

        try {
            const option = {
                tableName: tableName,
                condition: condition + code
            };

            const sourceData = await getVectorLayerSource(option);

            if(sourceData) {
                const borderLayerSource = new VectorSource({
                    features: new GeoJSON().readFeatures(sourceData.features[0])
                });
                layer.setSource(borderLayerSource);
    
                return borderLayerSource;
            }

        } catch(error) {
            console.log(error);
        }
    }

    const getVectorLayerSource = async ({ tableName, condition }) => {
        const option = {
            params: {
                service: 'WFS',
                version: '1.3.0',
                request: 'GetFeature',
                typeName: `gis_solution:${tableName}`,
                maxFeatures: 50,
                outputFormat: 'application/json',
                CQL_FILTER: condition,
            }
        };

        try {
            const response = await axios.get(`${GEOSERVER}/geoserver/gis_solution/ows`, option);
            return response.data;
        } catch(error) {
            return;
        }
    }

    return (
        <div css={s.mainContainer}>
            <div css={s.mapContainer}>
                <div id="map_area" css={s.mapArea}></div>
                {mode === "doubleMap" ? <div id="sub_map_area" css={[s.mapArea, s.subMap]}></div> : ""}
                {mode === "singleMap" ? 
                    <div css={s.mapPostSingle}>
                        <div css={s.legend}>
                            { selectedCategories.length > 1 && <img src={`/images/range/${selectedCategories[0].nm_en}.png`} alt={selectedCategories[0].nm_en}/> }
                        </div>
                    </div>
                    :
                    <div css={s.mapPostDouble}>
                        <div css={s.legend}>
                            { selectedCategories.length > 1 && <img src={`/images/range/${selectedCategories[0].nm_en}.png`} alt={selectedCategories[0].nm_en}/> }
                        </div>
                        <div css={s.legend}>
                            { selectedCategories.length > 1 && <img src={`/images/range/${selectedCategories[1].nm_en}.png`} alt={selectedCategories[1].nm_en}/> }
                        </div>
                    </div>
                }
                <div class="ol-tool-button-list">
                    <ModeSelectMenuButton mode={mode} setMode={setMode}/>
                </div>
            </div>
            <Popup popupData={popupData} selectedCategories={selectedCategories} onClickCloseButton={onClickCloseButton} mode={mode} index={0} />
            { mode === "doubleMap" &&
                <div>
                    <Popup popupData={popupData} selectedCategories={selectedCategories} onClickCloseButton={onClickCloseButton} mode={mode} index={1} />
                </div>
            }
            {mode === "swipeMap" ? <input id="swipe" type="range" style={{width: "100%"}} /> : ""}
        </div>
    );
};

export default CustomMap;